var map = {
	"./sec18_1.png": 572949,
	"./sec18_2.png": 780884,
	"./sec18_3.png": 53776,
	"./sec18_4.png": 15793,
	"./sec18_5.png": 79921,
	"./sec18_5_cn.png": 633181,
	"./sec18_5_eu.png": 137514,
	"./sec18_5_jp.png": 239310,
	"./sec18_5_us.png": 288467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 392985;